import React from "react";

function Header (){
    return(
        <React.Fragment>
            <div className="headerdivision">
            <h1 className="header">Expense Trekker</h1>
            
            </div>
        </React.Fragment>
    )
}

export default Header;